export function finTier(user) {
  if (!user) return "";
  const rn = user.role_name || "";
  if (user.role === "root" || rn === "Owner" || rn === "ROOT OWNER" || rn === "Finance Manager") return "MGR";
  if (rn === "Admin Finance") return "OPS";
  if (rn === "Controller") return "CTRL";
  if (rn === "Business Manager") return "BM";
  return "";
}

export const FIN_CONFIDENTIAL_ROLES = ["Owner", "ROOT OWNER", "Finance Manager", "Controller"];
